"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WayPointsList = WayPointsList;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function WayPointsList(_ref) {
  let {
    readonly,
    draggable,
    disableGap,
    children
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    className: [disableGap ? '' : 'space', draggable ? 'shifted' : '', readonly ? 'readonly' : ''].filter(Boolean).join(' ')
  }, children);
}
const Wrapper = _styledComponents.default.div`
  display: flex;
  flex-direction: column;
  position: relative;

  hr {
    margin-left: 26px;
  }

  > svg {
    position: absolute;
    left: 0;
  }

  &.space {
    gap: 16px;
  }

  &.shifted {
    hr {
      margin-left: 48px;
    }

    > svg {
      left: 22px;
    }
  }
`;